import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLocationComponent } from './components/select/select-location/select-location.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectAddressComponent } from './components/select/select-address/select-address.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AddressFormComponent } from './components/embedded/address-form/address-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '../shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LocationDetailViewComponent } from './components/main/location-detail-view/location-detail-view.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SelectLocationDialogComponent } from './components/dialog/select-location-dialog/select-location-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LocationPreviewComponent } from './components/preview/location-preview/location-preview.component';
import { LocationFormComponent } from './components/embedded/location-form/location-form.component';
import { QuillModule } from 'ngx-quill';
import { LocationAvailabilityTableComponent } from './components/embedded/location-availability-table/location-availability-table.component';
import { SelectLocation2Component } from './components/select/select-location2/select-location2.component';
import { LocationPipe } from './pipes/location.pipe';
import { LocationLabelComponent } from './components/label/location-label/location-label.component';
import { LocationObjectPipe } from './pipes/location-object.pipe';
import { CreateLocationDialogComponent } from './components/dialog/create-location-dialog/create-location-dialog.component';

@NgModule({
  declarations: [
    SelectLocationComponent,
    SelectAddressComponent,
    AddressFormComponent,
    LocationDetailViewComponent,
    SelectLocationDialogComponent,
    LocationPreviewComponent,
    LocationFormComponent,
    LocationAvailabilityTableComponent,
    SelectLocation2Component,
    LocationPipe,
    LocationLabelComponent,
    LocationObjectPipe,
    CreateLocationDialogComponent
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    SharedModule,
    QuillModule.forRoot()
  ],
  exports: [
    SelectAddressComponent,
    SelectLocationComponent,
    AddressFormComponent,
    LocationPreviewComponent
  ]
})
export class LocationModule { }
